import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'G Encontros',
  favIconName: 'favicon-g-encontros',
  name: 'gencontros',
};

export default branding;
